import { Button, Stack, Typography } from '@mui/material';
import { ActivityLogItem } from '@karehero/models';
import { ActivityRow } from '@/pwa/molecules/ActivityRow/ActivityRow';

export interface ActivityLogProps {
  items?: ActivityLogItem[];
  isLoading?: boolean;
  hasMore?: boolean;
  onLoadMore?: () => void;
  onRefresh?: () => void;
  onCareCircleClick?: (careCircleId: string) => void;
  getItemHref?: (item: ActivityLogItem) => string | undefined;
  onItemClick?: (item: ActivityLogItem) => void;
}

export const ActivityLog = ({
  items,
  isLoading,
  hasMore,
  onLoadMore,
  onRefresh,
  onCareCircleClick,
  getItemHref,
  onItemClick,
}: ActivityLogProps) => {
  if (isLoading && !items?.length) {
    return (
      <Typography
        variant='body2'
        sx={{
          color: 'text.secondary',
        }}
      >
        Loading...
      </Typography>
    );
  }

  if (!items?.length) {
    return (
      <Typography
        variant='body2'
        sx={{
          color: 'text.secondary',
        }}
      >
        No activity yet
      </Typography>
    );
  }

  return (
    <Stack spacing={0}>
      {onRefresh && (
        <Stack
          direction='row'
          sx={{
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant='text'
            size='small'
            onClick={onRefresh}
            disabled={isLoading}
          >
            Refresh
          </Button>
        </Stack>
      )}
      {items.map((item) => (
        <ActivityRow
          key={item.id}
          item={item}
          href={getItemHref?.(item)}
          onClick={onItemClick ? () => onItemClick(item) : undefined}
          onCareCircleClick={onCareCircleClick}
        />
      ))}
      {hasMore && onLoadMore && (
        <Button
          variant='text'
          size='small'
          onClick={onLoadMore}
          disabled={isLoading}
        >
          {isLoading ? 'Loading...' : 'Load more'}
        </Button>
      )}
    </Stack>
  );
};

export default ActivityLog;
